import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionContext, Round } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-poll-creation-context',
  templateUrl: 'poll-creation-context.component.html',
  styleUrls: ['./poll-creation-context.component.less', '../../../shared/common.less'],
})

export class PollCreationContextComponent implements OnInit {
  @Input() round: Round;
  @Input() electionContext: ElectionContext;
  @Input() selectedRound: boolean = true;
  @Output() selectedRoundChange = new EventEmitter<boolean>();
  @Output() contextChange = new EventEmitter<ElectionContext>();

  constructor() {}

  onRoundChange() {
    this.selectedRoundChange.emit(this.selectedRound);
  }

  onContextChange() {
    this.contextChange.emit(this.electionContext);
  }

  get fROpeningString(): string {
    return this.electionContext.expirationDate
      ? this.electionContext.expirationDate.toISOString().substring(0, 10)
      : '';
  }

  trackByIndex(index: number): number {
    return index;
  }

  ngOnInit(): void {
  }
}
